import axios from 'axios';

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:8080',
  withCredentials: true, // CRITICAL
});

/**
 * Auto-refresh on 401/403
 */
api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    // 1. Identify if the error came from the REFRESH call itself
    const isRefreshCall = originalRequest?.url?.includes('/auth/refresh') ?? false;

    if (
      originalRequest &&
      error.response &&
      (error.response.status === 401 || error.response.status === 403) &&
      !originalRequest._retry &&
      !isRefreshCall // <--- CRITICAL: Don't try to refresh if the refresh failed
    ) {
      originalRequest._retry = true;

      try {
        console.log('Token expired, attempting refresh...');
        await api.post('/auth/refresh'); 
        
        // Retry the original request with the new cookie/token
        return api.request(originalRequest);
      } catch (refreshError) {
        // If the refresh call fails, clear local auth and redirect
        console.error('Refresh token expired or invalid');
        // Example: logoutUser(); 
        return Promise.reject(refreshError);
      }
    }

    // If it was a 401 from the refresh call, it lands here
    return Promise.reject(error);
  }
);

export default api;
